export function getCollectionBackground(collection: Collection): Background | null {
    const { header = null, image = null } = collection || {};
    const { background = null } = header || {};
    if (background !== null) {
        return {
            ...background,
            imageFade: 'rgba(34,34,34, 0.1)',
        };
    }
    if (image !== null) {
        return {
            image,
            imageFade: 'rgba(34,34,34, 0.8)',
        };
    }
    return null;
}
